import { TaskCompletionStateFragment } from "gql/graphql";

/**
 * Когда задачу выполнили. У серии единой даты нет — отмечаются итерации, — поэтому
 * для неё всегда `null`.
 */
export function getTaskCompletedDate(
  task: TaskCompletionStateFragment,
): string | null {
  const { completion } = task;

  if (completion.__typename === "RecurringCompletionDto") {
    return null;
  }

  return completion.completedDate ?? null;
}
